import { Check, ArrowRight, Users, QrCode, Link2, Star, Clock, UserPlus, Globe, Briefcase, Building2, Share2, BadgeCheck, Zap, Home, Calculator, MessageSquare, Image, FileText, Mail, Monitor, Settings, Headphones, ShieldCheck, Lightbulb, ChevronDown, LineChart, TrendingUp } from "lucide-react";
import { DeferredSignupIframe } from "@/components/landing/DeferredSignupIframe";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import financialAdvisoryDiscover from "@/assets/financial-advisory-discover-new.png";
import financialAdvisoryCompetitiveEdge from "@/assets/financial-advisory-competitive-edge-new.png";
import InteractivePhoneMockup from "@/components/landing/InteractivePhoneMockup";
import ComparisonGridSection from "@/components/landing/ComparisonGridSection";
import companyLogos from "@/assets/company-logos.png";
import testimonialAaron from "@/assets/testimonial-aaron.png";
import testimonialTodd from "@/assets/testimonial-todd.png";
import testimonialNikki from "@/assets/testimonial-nikki.png";
import testimonialAnis from "@/assets/testimonial-anis.png";
import photoContactVideoNew from "@/assets/feature-photo-contact-video.mp4";
import analyticsVideoNew from "@/assets/feature-analytics-new.mp4";
import socialLinksVideoNew from "@/assets/social-media-links-v2.mp4";
import featureQrCodeVideo from "@/assets/qr-code-video.mp4";
import featureAddToContactsVideo from "@/assets/add-to-contacts-video.mp4";
import featureRichProfileVideo from "@/assets/rich-profile-content-video.mp4";
import colleaguesDemo from "@/assets/colleagues-demo.gif";
import featureTapToContactVideo from "@/assets/tap-to-contact-video.mp4";
import featureEmailFooterImage from "@/assets/email-footer-image.png";
import featureZoomBackgroundVideo from "@/assets/zoom-background-video.mp4";

const features = [{
  icon: Image,
  title: "Photo & Contact Info",
  description: "Professional headshot with all your contact details, Company role & About me section",
  image: photoContactVideoNew,
  isVideo: true
}, {
  icon: Briefcase,
  title: "Analytics",
  description: "Track networking impact with profile views, sources, and saved contacts",
  image: analyticsVideoNew,
  isVideo: true
}, {
  icon: Globe,
  title: "Social & Website Links",
  description: "Connect all your platforms in one place",
  image: socialLinksVideoNew,
  isVideo: true
}, {
  icon: QrCode,
  title: "QR Code",
  description: "Instant sharing with a simple scan",
  image: featureQrCodeVideo,
  isVideo: true
}, {
  icon: Link2,
  title: "Tap To Contact",
  description: "More contact options increase customer engagement rates",
  image: featureTapToContactVideo,
  isVideo: true
}, {
  icon: UserPlus,
  title: "Instant Add-to-Contacts",
  description: "One tap to save you to their phone",
  image: featureAddToContactsVideo,
  isVideo: true
}, {
  icon: FileText,
  title: "Rich Profile Content",
  description: "Tailor your profile to your needs",
  image: featureRichProfileVideo,
  isVideo: true
}, {
  icon: Share2,
  title: "Colleagues",
  description: "Show team members and access QCard profiles",
  image: colleaguesDemo
}, {
  icon: Mail,
  title: "Email Footers",
  description: "Add your QCard link to every email signature",
  image: featureEmailFooterImage,
  isVideo: false
}, {
  icon: Monitor,
  title: "Video Conference Background",
  description: "Brand your video calls with your QCard QR code",
  image: featureZoomBackgroundVideo,
  isVideo: true
}];

const benefits = [{
  icon: BadgeCheck,
  title: "Look Polished & Credible",
  description: "Make a professional first impression every time"
}, {
  icon: Zap,
  title: "Impress in Seconds",
  description: "Stand out with a modern, sleek digital presence"
}, {
  icon: Globe,
  title: "Works Anywhere",
  description: "Share via QR, link, or text — no app required"
}, {
  icon: UserPlus,
  title: "Get Saved Instantly",
  description: "Your contacts save you to their phone with one tap"
}];

const audiences = [{
  icon: Users,
  title: "Individuals",
  description: "Anyone who wants to network smarter",
  link: "https://www.qcardenterprise.com/4-reasons-why-every-professional-needs-a-digital-business-card"
}, {
  icon: Home,
  title: "Real Estate Agents",
  description: "Close deals with instant follow-up",
  link: "https://www.qcardenterprise.com/how-nfc-smart-business-cards-improve-client-trust-in-real-estate-and-finance"
}, {
  icon: MessageSquare,
  title: "Consultants",
  description: "Build credibility from the first meeting",
  link: "https://www.qcardenterprise.com/consulting-confidence-5-essential-elements-every-consultant-needs-on-their-digital-business-card"
}, {
  icon: Calculator,
  title: "Financial Professionals",
  description: "Establish trust with a polished profile",
  link: "https://www.qcardenterprise.com/building-trust-in-the-digital-age-essential-elements-for-a-financial-advisors-digital-business-card"
}, {
  icon: Briefcase,
  title: "Lawyers",
  description: "Present a professional image to clients",
  link: "https://www.qcardenterprise.com/digital-business-cards-for-lawyers-how-to-impress-clients-with-tech"
}, {
  icon: Building2,
  title: "Enterprises",
  description: "Equip your entire team with digital cards",
  link: "https://www.qcardenterprise.com/enterprise-branding-in-the-digital-age-why-every-team-member-deserves-a-profile"
}];

const enterpriseFeatures = [{
  icon: Settings,
  title: "Integrates With Your Enterprise",
  color: "bg-blue-100 text-blue-600",
  items: ["Integrations with enterprise HRMS and CRM systems", "Unified and controlled platform to manage employee network and access", "APIs", "Custom URLs tailored to your company's domain"]
}, {
  icon: Headphones,
  title: "Enterprise-Level Customer Support",
  color: "bg-orange-100 text-orange-500",
  items: ["Seamless and quick user onboarding and system implementation", "Employee training on how to use the platform", "24/7 Helpdesk", "360-Degree Customer Success Team", "Personal Concierge", "Rollout support"]
}, {
  icon: ShieldCheck,
  title: "Secure",
  color: "bg-pink-100 text-pink-500",
  items: ["Single Sign-On", "Enterprise-grade security", "On Prem/Cloud Solutions"]
}, {
  icon: Lightbulb,
  title: "Custom Solutions",
  color: "bg-green-100 text-green-500",
  items: ["Collaborate with the QCard team to tailor solutions for the specific needs of your enterprise", "In-house experts for expanded customer experience solutions"]
}];

const steps = [{
  step: "01",
  title: "Create Your Free QCard",
  description: "Sign up in seconds — no credit card needed"
}, {
  step: "02",
  title: "Customize Your Profile",
  description: "Add your photo, bio, links, and contact info"
}, {
  step: "03",
  title: "Share Instantly",
  description: "Use your QR code or personal link anywhere"
}];

const testimonials = [{
  image: testimonialAaron,
  name: "Aaron Pyman",
  company: "Redfin",
  link: "https://www.linkedin.com/in/aaronpyman/"
}, {
  image: testimonialAnis,
  name: "Anis Dave",
  company: "from - The Digital Transformation Agency",
  link: "https://www.linkedin.com/in/aaronpyman/"
}, {
  image: testimonialNikki,
  name: "Nikki Beauchamp",
  company: "Sotheby's International Realty",
  link: "https://www.linkedin.com/in/nicolebeauchamp/"
}, {
  image: testimonialTodd,
  name: "Todd Edwards",
  company: "Redfin",
  link: "https://www.linkedin.com/in/rtoddedwards/"
}];

const FinancialAdvisoryDigitalBusinessCard = () => {
  const [selectedFeature, setSelectedFeature] = useState(0);
  const [isEnterpriseExpanded, setIsEnterpriseExpanded] = useState(false);

  return (
    <div className="min-h-screen bg-background text-foreground">
      {/* Hero Section - Enterprise Style */}
      <section id="signup-section" className="relative overflow-hidden">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-secondary/50 via-background to-accent/30" />
        
        {/* Lightweight decorative elements - static, no motion */}
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-gradient-to-bl from-enterprise-purple/15 via-purple-200/10 to-transparent rounded-full blur-3xl -translate-y-1/3 translate-x-1/4" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-gradient-to-tr from-orange-200/15 via-amber-100/10 to-transparent rounded-full blur-3xl translate-y-1/4 -translate-x-1/4" />
        
        <div className="container relative z-10 mx-auto px-4 sm:px-6 py-16 md:py-24">
          <div className="grid lg:grid-cols-3 gap-8 lg:gap-6 items-start max-w-full overflow-hidden">
            {/* Left Content */}
            <div 
              className="text-center lg:text-left w-full max-w-full px-2 sm:px-0 lg:pt-24 order-1 lg:order-none flex flex-col"
            >
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-2 text-foreground">
                Trust Is the Currency of Financial Advice.{" "}
                <span className="text-gradient">QCard Builds It Instantly.</span>
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground mb-4">
                A free digital business card built for Financial Advisors.
              </p>
              <p 
                className="inline-flex items-center justify-center lg:justify-start gap-2 text-base font-bold mb-6 bg-gradient-to-r from-enterprise-purple to-enterprise-purple-dark bg-clip-text text-transparent w-full"
              >
                FREE Forever — No Credit Card Required
              </p>
              
              {/* Mobile Phone Mockup */}
              <div className="lg:hidden flex flex-col items-center justify-start w-full max-w-full mb-8">
                <InteractivePhoneMockup defaultProfileIndex={4} showProfileSwitcher={true} />
              </div>
              
              <p className="text-lg text-muted-foreground mb-4 max-w-xl mx-auto lg:mx-0">
                QCard makes sharing expertise effortless, professional, and trackable. From client meetings to seminars, make every introduction count.
              </p>
              
              <div className="mb-8 text-base text-muted-foreground max-w-xl mx-auto lg:mx-0">
                <p className="font-medium text-foreground mb-2 text-lg">Perfect for:</p>
                <ul className="space-y-1.5">
                  <li>• Client meetings and portfolio reviews</li>
                  <li>• Networking events and seminars</li>
                  <li>• Referral partnerships and introductions</li>
                </ul>
              </div>
              
              <div className="flex flex-wrap items-center gap-4 justify-center lg:justify-start text-base text-muted-foreground">
                <div className="flex items-center gap-2">
                  <Check className="w-5 h-5 text-enterprise-purple" />
                  <span>Feature Rich</span>
                </div>
                <div className="flex items-center gap-2">
                  <Check className="w-5 h-5 text-enterprise-purple" />
                  <span>60-second setup</span>
                </div>
                <div className="flex items-center gap-2">
                  <Check className="w-5 h-5 text-enterprise-purple" />
                  <span>No Ads</span>
                </div>
              </div>
            </div>

            {/* Center - Interactive Phone Demo (Desktop only) */}
            <div className="hidden lg:flex flex-col items-center justify-start order-2 lg:order-none w-full max-w-full">
              <InteractivePhoneMockup defaultProfileIndex={4} showProfileSwitcher={true} />
            </div>

            {/* Right - Sign Up Form */}
            <div className="flex flex-col justify-start items-center lg:items-end w-full max-w-full order-3 lg:order-none">
              <div className="bg-card rounded-2xl p-4 shadow-2xl border border-border w-full max-w-md overflow-hidden mx-auto lg:mx-0">
                <div className="flex items-center justify-center min-h-[60px] mb-4">
                  <h2 className="text-xl font-bold text-center text-foreground">
                    Financial Advisors Sign up for your<br />FREE Digital Business Card
                  </h2>
                </div>
                <DeferredSignupIframe
                  src="https://qa.qcardenterprise.com/createNewUserAccount"
                  title="Financial Advisor Signup Form"
                  height={630}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Logos */}
      <section className="py-12 bg-muted/30 border-y border-border" style={{ contentVisibility: 'auto', containIntrinsicSize: 'auto 150px' }}>
        <div className="container mx-auto px-4">
          <p className="text-center text-muted-foreground mb-8 text-sm font-medium">
            Trusted by professionals at leading companies
          </p>
          <img 
            src={companyLogos} 
            alt="Trusted by Redfin, Keller Williams, UBS, S&P Global, Sotheby's, Compass, and more" 
            className="max-w-4xl mx-auto w-full"
            width={896}
            height={80}
            loading="lazy"
            decoding="async"
          />
        </div>
      </section>

      {/* Discover QCard Section */}
      <section className="relative py-16 md:py-24 bg-background overflow-hidden" style={{ contentVisibility: 'auto', containIntrinsicSize: 'auto 600px' }}>
        <div className="container mx-auto px-4 relative z-10">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-1/2">
              <img
                src={financialAdvisoryDiscover}
                alt="QCard digital business card for financial advisors"
                className="w-full h-auto max-w-lg lg:max-w-3xl mx-auto rounded-2xl"
                loading="lazy"
                decoding="async"
              />
            </div>
            
            <div className="lg:w-1/2 text-center lg:text-left">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
                Discover QCard
              </h2>
              <p className="text-lg text-muted-foreground mb-4">
                QCard is a modern digital business card and branding tool built for financial advisors. Each advisor can create an elegant online profile showcasing their contact details, credentials, and areas of specialization.
              </p>
              <p className="text-lg text-muted-foreground mb-4">
                The profile makes it simple to highlight services, share insights, and provide clients with secure, convenient access in a sleek digital format.
              </p>
              <p className="text-lg text-muted-foreground mb-8">
                QCard goes beyond a business card, offering a branded profile where prospects and clients can access all your professional information in one place.
              </p>
              <div className="flex flex-col items-center lg:items-start">
                <Button
                  className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-8 py-4 h-auto rounded-lg shadow-lg hover:shadow-xl"
                  onClick={() => document.getElementById('signup-section')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Create Your Digital Card Free
                </Button>
                <div className="mt-3 flex flex-col sm:flex-row items-center gap-2 text-sm text-muted-foreground">
                  <span>No credit card required</span>
                  <span className="hidden sm:inline">•</span>
                  <span>Takes less than 2 minutes</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Competitive Edge Section */}
      <section className="relative py-16 md:py-24 bg-muted/30 overflow-hidden" style={{ contentVisibility: 'auto', containIntrinsicSize: 'auto 600px' }}>
        <div className="container mx-auto px-4 relative z-10">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="lg:w-3/5">
              <img
                src={financialAdvisoryCompetitiveEdge}
                alt="Financial advisory competitive edge"
                className="w-full h-auto max-w-lg lg:max-w-3xl mx-auto rounded-2xl"
                loading="lazy"
                decoding="async"
              />
            </div>
            
            <div className="lg:w-2/5 text-center lg:text-left">
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
                Competitive Edge
              </h2>
              <p className="text-lg text-muted-foreground mb-4">
                First impressions matter in finance. QCards help advisors turn introductions into lasting relationships by replacing paper cards with a digital gateway to their expertise.
              </p>
              <p className="text-lg text-muted-foreground mb-8">
                Give Your Financial Advisory Firm a Competitive Advantage. Sign up for our Pilot Program!
              </p>
              <div className="flex flex-col items-center lg:items-start">
                <Button
                  className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-8 py-4 h-auto rounded-lg shadow-lg hover:shadow-xl"
                  onClick={() => document.getElementById('signup-section')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Create Your Digital Card Free
                </Button>
                <div className="mt-3 flex flex-col sm:flex-row items-center gap-2 text-sm text-muted-foreground">
                  <span>No credit card required</span>
                  <span className="hidden sm:inline">•</span>
                  <span>Takes less than 2 minutes</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* All Features. No Fees. */}
      <section className="py-20 md:py-28 bg-background" style={{ contentVisibility: 'auto', containIntrinsicSize: 'auto 800px' }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              All Features. <span className="text-gradient">No Fees.</span>
            </h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Everything you need to create a professional digital presence — included free.
            </p>
          </div>

          <div className="hidden md:flex flex-col md:flex-row gap-8 md:gap-12 max-w-6xl mx-auto mt-8">
            <div className="w-full md:w-2/5">
              <div className="grid grid-cols-2 gap-3">
                {features.map((feature, index) => (
                  <button 
                    key={index} 
                    onClick={() => setSelectedFeature(index)} 
                    className={`p-4 rounded-xl text-left transition-all duration-300 border ${selectedFeature === index ? 'bg-enterprise-purple text-white border-enterprise-purple shadow-lg' : 'bg-card border-border hover:border-enterprise-purple/50 hover:bg-muted/50'}`}
                  >
                    <feature.icon className={`w-6 h-6 mb-2 ${selectedFeature === index ? 'text-white' : 'text-enterprise-purple'}`} />
                    <h3 className={`font-semibold text-sm ${selectedFeature === index ? 'text-white' : 'text-foreground'}`}>
                      {feature.title}
                    </h3>
                  </button>
                ))}
              </div>
            </div>

            <div className="w-full md:w-3/5">
              <div className="bg-muted/30 rounded-2xl overflow-hidden border border-border shadow-lg">
                {features[selectedFeature].isVideo ? (
                  <video src={features[selectedFeature].image} autoPlay loop muted playsInline className="w-full h-auto object-contain" />
                ) : (
                  <img src={features[selectedFeature].image} alt={features[selectedFeature].title} className="w-full h-auto object-contain" />
                )}
              </div>
              <div className="mt-6 text-center">
                <h3 className="text-xl md:text-2xl font-bold mb-3 text-foreground">
                  {features[selectedFeature].title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {features[selectedFeature].description}
                </p>
              </div>
            </div>
          </div>

          {/* Mobile: Show all features stacked */}
          <div className="md:hidden mt-12 space-y-8">
            {features.map((feature, index) => (
              <div key={index} className="text-center">
                <div className="bg-muted/30 rounded-2xl overflow-hidden border border-border shadow-lg mb-4">
                  {feature.isVideo ? (
                    <video src={feature.image} autoPlay loop muted playsInline className="w-full h-auto object-contain" />
                  ) : (
                    <img src={feature.image} alt={feature.title} className="w-full h-auto object-contain" />
                  )}
                </div>
                <h3 className="text-xl font-bold mb-2 text-foreground">{feature.title}</h3>
                <p className="text-muted-foreground">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why QCard Is Best for Financial Professionals */}
      <section className="py-20 md:py-28 bg-muted/30" style={{ contentVisibility: 'auto', containIntrinsicSize: 'auto 800px' }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              Why QCard Is <span className="text-gradient">Built for Financial Professionals</span>
            </h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Your expertise builds portfolios. QCard ensures clients remember you when it's time to invest.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto mb-12">
            <div className="bg-card border border-border rounded-2xl p-8 hover:border-enterprise-purple/30 hover:shadow-lg transition-all duration-300">
              <div className="w-14 h-14 rounded-xl bg-enterprise-purple/10 flex items-center justify-center mb-6">
                <TrendingUp className="w-7 h-7 text-enterprise-purple" />
              </div>
              <h3 className="font-bold text-xl mb-3">Trust Is Everything</h3>
              <p className="text-muted-foreground">
                Clients entrust you with their financial future. A polished QCard profile with your credentials, certifications, and expertise builds confidence before the first meeting.
              </p>
            </div>

            <div className="bg-card border border-border rounded-2xl p-8 hover:border-enterprise-purple/30 hover:shadow-lg transition-all duration-300">
              <div className="w-14 h-14 rounded-xl bg-enterprise-purple/10 flex items-center justify-center mb-6">
                <Users className="w-7 h-7 text-enterprise-purple" />
              </div>
              <h3 className="font-bold text-xl mb-3">Every Client Meeting Counts</h3>
              <p className="text-muted-foreground">
                Financial advisory is a relationship business. After every portfolio review or planning session, your contact details need to land in their phone — not get lost.
              </p>
            </div>

            <div className="bg-card border border-border rounded-2xl p-8 hover:border-enterprise-purple/30 hover:shadow-lg transition-all duration-300">
              <div className="w-14 h-14 rounded-xl bg-enterprise-purple/10 flex items-center justify-center mb-6">
                <LineChart className="w-7 h-7 text-enterprise-purple" />
              </div>
              <h3 className="font-bold text-xl mb-3">Referrals Made Effortless</h3>
              <p className="text-muted-foreground">
                When a satisfied client wants to recommend you, they can instantly share your QCard link. No digging for business cards, no typos — just seamless introductions.
              </p>
            </div>
          </div>

          <div className="max-w-3xl mx-auto text-center mb-12 bg-gradient-to-br from-enterprise-purple/5 to-enterprise-purple/10 border border-enterprise-purple/20 rounded-2xl p-8">
            <p className="text-xl font-medium text-foreground mb-4">
              "The best financial advisors don't just manage wealth — they're unforgettable."
            </p>
            <p className="text-muted-foreground">
              Stop handing out paper cards that disappear. Start building a digital presence that gets you referred again and again.
            </p>
            <Button 
              size="lg" 
              className="mt-6 bg-enterprise-purple hover:bg-enterprise-purple-dark text-white text-lg px-8 py-6 font-semibold shadow-lg shadow-enterprise-purple/30" 
              onClick={() => document.getElementById('signup-section')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Create Your Free QCard
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>

          <div className="mt-12 text-center">
            <p className="text-muted-foreground mb-4">
              <Building2 className="w-4 h-4 inline mr-2" />
              Need QCard for your team?
            </p>
            <Button 
              size="lg" 
              className="bg-enterprise-purple hover:bg-enterprise-purple-dark text-white text-xl px-12 py-8 font-bold shadow-xl shadow-enterprise-purple/30" 
              onClick={() => setIsEnterpriseExpanded(!isEnterpriseExpanded)}
            >
              Enterprise Plan Available
              <ChevronDown className={`ml-3 w-6 h-6 transition-transform duration-300 ${isEnterpriseExpanded ? 'rotate-180' : ''}`} />
            </Button>
            
            {/* Expanding Enterprise Content */}
            <div className={`overflow-hidden transition-all duration-500 ease-in-out ${isEnterpriseExpanded ? 'max-h-[2000px] opacity-100 mt-12' : 'max-h-0 opacity-0 mt-0'}`}>
              <div className="max-w-3xl mx-auto text-center mb-12">
                <h3 className="text-2xl md:text-3xl font-bold mb-4">
                  Designed for <span className="text-enterprise-purple">Enterprises</span>, from the Ground Up
                </h3>
                <p className="text-lg text-muted-foreground">
                  QCard provides the cutting edge features, infrastructure, security and support that enterprises need.
                </p>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto text-left">
                {enterpriseFeatures.map((feature, index) => (
                  <div key={index} className="bg-card border border-border rounded-2xl p-6 hover:shadow-lg transition-all duration-300">
                    <div className={`w-14 h-14 rounded-2xl ${feature.color} flex items-center justify-center mb-4`}>
                      <feature.icon className="w-7 h-7" />
                    </div>
                    <h4 className="text-lg font-bold mb-3">{feature.title}</h4>
                    <ul className="space-y-2">
                      {feature.items.map((item, itemIndex) => (
                        <li key={itemIndex} className="flex items-start gap-2 text-muted-foreground text-sm">
                          <Check className="w-4 h-4 text-enterprise-purple flex-shrink-0 mt-0.5" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              
              <div className="mt-8 text-center">
                <Button 
                  size="lg" 
                  className="bg-orange-500 hover:bg-orange-600 text-white text-lg px-10 py-6 font-semibold" 
                  onClick={() => document.getElementById('signup-section')?.scrollIntoView({ behavior: 'smooth' })}
                >
                  Get Started Free
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-20 md:py-28 bg-background" style={{ contentVisibility: 'auto', containIntrinsicSize: 'auto 400px' }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              How It <span className="text-gradient">Works</span>
            </h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Get your professional digital card in three easy steps
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {steps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="relative inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-enterprise-purple to-enterprise-purple-dark text-white font-bold text-xl mb-6">
                  {step.step}
                </div>
                <h3 className="text-xl font-bold mb-3">{step.title}</h3>
                <p className="text-muted-foreground">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Who Is QCard For? */}
      <section className="py-20 md:py-28 bg-muted/30" style={{ contentVisibility: 'auto', containIntrinsicSize: 'auto 500px' }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              Who Is QCard <span className="text-gradient">For?</span>
            </h2>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Perfect for professionals who want to stand out and stay connected
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {audiences.map((audience, index) => (
              <a 
                key={index} 
                href={audience.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="group bg-card border border-border rounded-2xl p-6 hover:border-enterprise-purple/30 hover:shadow-lg transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-xl bg-enterprise-purple/10 flex items-center justify-center mb-4 group-hover:bg-enterprise-purple/20 transition-colors">
                  <audience.icon className="w-6 h-6 text-enterprise-purple" />
                </div>
                <h3 className="font-bold text-lg mb-2">{audience.title}</h3>
                <p className="text-muted-foreground text-sm">{audience.description}</p>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose QCard */}
      <section className="py-20 md:py-28 bg-background" style={{ contentVisibility: 'auto', containIntrinsicSize: 'auto 600px' }}>
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-16 items-center max-w-6xl mx-auto">
            <div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
                Why Choose <span className="text-gradient">QCard?</span>
              </h2>
              <p className="text-xl text-muted-foreground mb-8">
                In a world of forgettable first impressions, QCard helps you stand out and stay connected.
              </p>
              
              <div className="space-y-4">
                {["Be remembered — not just another card in the drawer", "Be searchable — your digital profile lives online", "Look professional — polished, modern, and credible", "Stand out — make every interaction count", "Replace outdated paper cards — go digital, go green"].map((item, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <div className="w-6 h-6 rounded-full bg-enterprise-purple/20 flex items-center justify-center flex-shrink-0">
                      <Check className="w-4 h-4 text-enterprise-purple" />
                    </div>
                    <span className="text-lg">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Old Way vs QCard */}
            <div className="grid gap-6">
              <div className="bg-card border border-border rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-destructive/10 flex items-center justify-center">
                    <span className="text-destructive font-bold">✕</span>
                  </div>
                  <h3 className="font-semibold text-lg">The Old Way</h3>
                </div>
                <ul className="space-y-2 text-muted-foreground">
                  <li>• Paper cards get lost or thrown away</li>
                  <li>• Manual contact entry (if they bother)</li>
                  <li>• Outdated info after a job change</li>
                  <li>• No way to share digitally</li>
                  <li>• Limited first impression</li>
                </ul>
              </div>

              <div className="bg-gradient-to-br from-enterprise-purple/5 to-enterprise-purple/10 border border-enterprise-purple/20 rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full bg-enterprise-purple/20 flex items-center justify-center">
                    <Check className="w-5 h-5 text-enterprise-purple" />
                  </div>
                  <h3 className="font-semibold text-lg">The QCard Way</h3>
                </div>
                <ul className="space-y-2">
                  <li className="flex items-center gap-2">
                    <Check className="w-4 h-4 text-enterprise-purple flex-shrink-0" />
                    <span>Saved directly to their phone</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-4 h-4 text-enterprise-purple flex-shrink-0" />
                    <span>One-tap contact saving</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-4 h-4 text-enterprise-purple flex-shrink-0" />
                    <span>Always up-to-date</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-4 h-4 text-enterprise-purple flex-shrink-0" />
                    <span>Share via QR, link, or text</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <Check className="w-4 h-4 text-enterprise-purple flex-shrink-0" />
                    <span>Professional, memorable impression</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Competitor Comparison */}
      <ComparisonGridSection />

      {/* Free Tier Callout */}
      <section className="py-20 md:py-28 bg-gradient-to-br from-enterprise-purple/5 via-background to-enterprise-purple/10" style={{ contentVisibility: 'auto', containIntrinsicSize: 'auto 500px' }}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-enterprise-purple/10 text-enterprise-purple text-sm font-semibold mb-6 border border-enterprise-purple/20">
              <Star className="w-4 h-4" />
              Free Tier. Full Capability.
            </div>
            
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
              This Isn't a "Basic" Version.<br />
              <span className="text-gradient">It's the Real Thing.</span>
            </h2>
            
            <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
              We believe everyone deserves a professional digital presence. That's why QCard Free includes 
              every feature you need — no artificial limitations, no paywalls for essentials.
            </p>

            <div className="flex flex-wrap justify-center gap-4 mb-8">
              {["Full Profile", "Unlimited Sharing", "QR Code", "Personal URL", "Contact Saving", "All Links"].map((item, index) => (
                <div key={index} className="flex items-center gap-2 bg-card border border-border rounded-full px-4 py-2">
                  <Check className="w-4 h-4 text-green-600" />
                  <span className="text-sm font-medium">{item}</span>
                </div>
              ))}
            </div>

            <Button 
              size="lg" 
              className="bg-enterprise-purple hover:bg-enterprise-purple-dark text-white text-lg px-10 py-6 font-semibold shadow-lg shadow-enterprise-purple/30" 
              onClick={() => document.getElementById('signup-section')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Create Your Free QCard
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 md:py-28 bg-muted/30" style={{ contentVisibility: 'auto', containIntrinsicSize: 'auto 500px' }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
              What Professionals <span className="text-gradient">Are Saying</span>
            </h2>
          </div>

          {/* Desktop: Grid */}
          <div className="hidden md:grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
            {testimonials.map((testimonial, index) => (
              <a 
                key={index} 
                href={testimonial.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="block overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-[1.02]"
              >
                <img src={testimonial.image} alt={`${testimonial.name} from ${testimonial.company} testimonial`} className="w-full h-auto" />
              </a>
            ))}
          </div>

          {/* Mobile: Carousel */}
          <div className="md:hidden max-w-sm mx-auto px-8">
            <Carousel 
              opts={{ align: "center", loop: true }} 
              plugins={[Autoplay({ delay: 4000, stopOnInteraction: false, stopOnMouseEnter: true })]} 
              className="w-full"
            >
              <CarouselContent>
                {testimonials.map((testimonial, index) => (
                  <CarouselItem key={index}>
                    <div className="p-2">
                      <a href={testimonial.link} target="_blank" rel="noopener noreferrer" className="block overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-[1.02]">
                        <img src={testimonial.image} alt={`${testimonial.name} from ${testimonial.company} testimonial`} className="w-full h-auto" />
                      </a>
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious className="left-0 bg-background/80 hover:bg-background border-border" />
              <CarouselNext className="right-0 bg-background/80 hover:bg-background border-border" />
            </Carousel>

            <div className="flex justify-center gap-2 mt-6">
              {testimonials.map((_, index) => (
                <div key={index} className="w-2 h-2 rounded-full bg-enterprise-purple/30 transition-colors" />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-24 md:py-32 bg-gradient-to-br from-foreground to-foreground/90 text-background">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Create Your Free QCard — It Only Takes 60 Seconds.
          </h2>
          <p className="text-xl text-background/70 mb-10 max-w-2xl mx-auto">
            No credit card required. All features included. Start making lasting impressions today.
          </p>
          
          <Button 
            size="lg" 
            className="bg-enterprise-purple hover:bg-enterprise-purple-dark text-white text-xl px-12 py-8 font-semibold shadow-xl shadow-enterprise-purple/40" 
            onClick={() => document.getElementById('signup-section')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Create Your Free QCard
            <ArrowRight className="ml-3 h-6 w-6" />
          </Button>

          <div className="flex items-center gap-8 justify-center mt-10 text-sm text-background/60">
            <div className="flex items-center gap-2">
              <Clock className="w-4 h-4" />
              <span>60-second setup</span>
            </div>
            <div className="flex items-center gap-2">
              <Check className="w-4 h-4" />
              <span>No credit card</span>
            </div>
            <div className="flex items-center gap-2">
              <Star className="w-4 h-4" />
              <span>All features free</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FinancialAdvisoryDigitalBusinessCard;
